/**
 * Settings page
 */
import React, { ReactElement } from 'react'
import { Card, Typography, Divider, Space } from 'antd'
import styles from './Settings.module.scss'

const { Title, Paragraph } = Typography

const Settings = (): ReactElement => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Card>
          <Title level={2}>Settings</Title>
          <Divider />
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <div>
              <Title level={4}>General</Title>
              <Paragraph>
                Configure your VirtualLog application settings here.
              </Paragraph>
            </div>
            <div>
              <Title level={4}>Log Retention</Title>
              <Paragraph>
                Manage how long logs are stored in the system.
              </Paragraph>
            </div>
            <div>
              <Title level={4}>Notifications</Title>
              <Paragraph>
                Configure alert rules and notification preferences.
              </Paragraph>
            </div>
          </Space>
        </Card>
      </div>
    </div>
  )
}

export default Settings
